import { VueMaskDirective } from 'v-mask';

Vue.directive('mask', VueMaskDirective);

Vue.directive('focus', {
    inserted(el) {
        const input = el.querySelector('input') || el;

        input.focus();
    },
});

Vue.directive('modal-autofocus', {
    inserted(el) {
        $(el).on('shown.bs.modal', () => {
            $('input', el).first().focus();
        });
    },
});

Vue.directive('select-focus', {
    inserted(el) {
        el.addEventListener('focus', () => {
            if (!el) {
                return;
            }

            el.select();
        });
    },
});
